module.exports = __webpack_public_path__ + "img/BA.bdb68455.png";